<template>
    <div class="field">
        <div class="control">
            <div v-if="isTimePicker">
              <o-datetimepicker
                  icon="calendar"
                  trap-focus
                  :placeholder="placeholder"
                  :model-value="date"
                  @update:modelValue="date = $event"
              >
              </o-datetimepicker>
            </div>
            <div v-else>
              <o-datepicker
                  :placeholder="placeholder"
                  :model-value="date"
                  @update:modelValue="date = $event"
                  icon="calendar"
                  trap-focus
              >
              </o-datepicker>
            </div>

            <span v-if="date" @click="$emit('input', null)" class="icon reset-icon">
                <i class="fa fa-close fa-lg"></i>
            </span>
            <form-error :error="error" />
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {ref} from "vue";

    export default {

        name: "Datepicker",

        props: {
            config: {
                type: Object,
                default () {
                    return {}
                }
            },
            value: {},
            error: {},
            enableTime: {},
            inputClass: {
                type: String,
                default: 'input'
            },
            placeholder: {
                type: String,
                default: 'Pick a date'
            },
            isTimePicker: {
              type: Boolean,
              default: false
            }
        },

        computed: {
            computedConfig(){
                var enableTime = this.enableTime
                return { dateFormat: enableTime ? 'm/d/Y h:i K' : 'm/d/Y', enableTime, ...(this.config || {}) }
            },
            date: {
              get() {
                return this.value ? moment(this.value).toDate() : null
              },
              set(value) {
                this.$emit('update:modelValue', moment(value).format('YYYY-MM-DD HH:mm:ss'))
              }
            }
        }
    }
</script>

<style>
.reset-icon {
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 3px; }
.reset-icon .reset-icon i {
  font-size: 1rem;
  color: #019ae0; }
.reset-icon .control {
  position: relative; }

.datepicker > .dropdown{
  position: static !important;
}

</style>
